//--------------------------------------------------------------------------
// <copyright file="PairingStatesEnum.js" company="Microsoft">
// Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------

/// <summary>
/// Enum having various states during the pairing flow.
/// </summary>
const PairingStates = {
    PairingCodeNotEntered: 0,
    PairingCodeError: 1,
    PairingInProgress: 2,
    PairingStatusPending: 3,
    PairingAuthorizationFailed: 4,
}

export default PairingStates;